import MainController from '../../controllers/MainController';

const styles = {
  root: {
    height: '30% !important',
    minHeight: 'fit-content',
    top: '70%',
  },
  paper: {
    left: 0,
    bottom: 0,
    position: 'absolute',
    margin: MainController.showMobileVersion() ? 0 : 20,
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/notifications/NotificationDialogStyles.js